<template>
  <div>
    <div v-for="(page, index) in pages" :key="'page-' + index" class="position-relative dinA4">
      <!-- Header image -->
      <img :src="require('@/assets/signature-header.png')" class="page__header" />

      <!-- Content -->
      <div class="page__container">
        <div v-if="index === 0">
          <div class="d-flex justify-center mt-0 mb-2">
            <p class="h1 h1--bold mt-0">
              {{ $t('PAGE_SIGNATURE_TITLE') }}
            </p>
          </div>
          <table class="full-width">
            <tr class="primary-background">
              <th class="primary-background h1 color-white text-left pl-4 pb-2">Datos Cliente</th>
              <th class="primary-background h1 color-white text-left pl-4" />
            </tr>
            <tr>
              <td class="body-1 body-1--bold">
                {{ clientSocialReason }}
              </td>
            </tr>
            <tr>
              <td class="body-2 body-2--italic">Razón Social</td>
            </tr>
          </table>

          <table>
            <tr>
              <td class="body-1 body-1--bold">
                {{ clientData.cif }}
              </td>
            </tr>
            <tr>
              <td class="body-2 body-2--italic">NIF/CIF</td>
            </tr>
          </table>

          <table>
            <tr>
              <td class="body-1 body-1--bold">
                {{ clientData.address }}
              </td>
            </tr>
            <tr>
              <td class="body-2 body-2--italic">Domicilio social</td>
            </tr>
          </table>

          <p class="body-2 mt-0 mb-2 pl-2 pr-2 justify-text">
            Precios pactados para un volumen MÍNIMO de
            <b>{{ commitedDeliveries }} envíos al mes</b> y para los puntos de recogida habitual
            especificados en el presente Acuerdo Mercantil de Prestación de Servicios. El marco
            tarifario contemplado en estas condiciones podrá ser modificado por CTT Express, si la
            disposición de envíos admitidos tuviera grandes oscilaciones (+/- 5%) relativo a la
            dispersión estándar en función a la densidad por núcleo de población.
          </p>
        </div>

        <!-- tabla Puntos de recogida  -->
        <table class="full-width mb-1">
          <thead v-if="index === 0">
            <tr class="primary-background">
              <th class="primary-background h1 color-white text-left pl-4 pb-2">
                Puntos de Recogida Habitual
              </th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody v-for="(servicePoint, i) in pageGroupedServicePoints[index]" :key="i">
            <tr class="valign-bottom">
              <td class="body-2 body-2--bold">
                <span colspan="2" class="body-1 body-1--bold">
                  {{ servicePoint.address1 }} {{ servicePoint.address2 }} </span
                ><br />
                {{ servicePoint.postalCode }}, {{ servicePoint.cityName }} -
                {{ servicePoint.provinceName }} {{ servicePoint.isoCountry }}
              </td>
              <td class="body-1 body-1--bold">
                {{ servicePoint.compromisedShipments }}
              </td>
            </tr>
            <tr>
              <td class="body-2 body-2--italic">Dirección</td>
              <td class="body-2 body-2--italic">Envíos Comprometidos/mes</td>
            </tr>
          </tbody>
        </table>

        <template v-if="index + 1 === pages">
          <!-- Tabla Datos de Facturación -->
          <div>
            <table class="full-width">
              <tr class="primary-background">
                <th class="primary-background h1 color-white text-left pl-4 pb-2">
                  Datos de Facturación
                </th>
                <th class="primary-background h1 color-white text-left pl-4" />
              </tr>
              <tr>
                <td class="body-1 body-1--bold pt-2 pb-2">
                  {{ $t(selectedPaymentMethod.desc_key) }}
                </td>
              </tr>
              <tr>
                <td class="body-2 body-2--italic pt-0 pb-0">Forma de pago</td>
              </tr>
              <tr>
                <td class="body-1 body-1--bold">
                  {{ paymentDay }}
                </td>
              </tr>
              <tr class="mt-n4">
                <td class="body-2 body-2--italic">Día de pago</td>
              </tr>
              <tr>
                <td class="body-1 body-1--bold">
                  <span>{{ bankData.accountIBAN }}</span>
                </td>
              </tr>
              <tr class="mt-n4">
                <td class="body-2 body-2--italic">Cuenta para Recibo Bancario</td>
              </tr>
              <tr>
                <td class="body-1 body-1--bold">
                  <span>{{ bankData.iban2 !== "" ? bankData.iban2 : bankData.accountIBAN }}</span>
                </td>
              </tr>
              <tr class="mt-n4">
                <td class="body-2 body-2--italic">Cuenta para Liquidación de Reembolsos</td>
              </tr>
            </table>
          </div>

          <!-- Firma -->
          <table class="full-width">
            <tr class="primary-background">
              <th class="primary-background h1 color-white text-left pl-4 pb-2">Firma</th>
              <th class="primary-background h1 color-white text-left pl-4" />
            </tr>
            <tr>
              <td class="body-2 body-2--italic">{{ location }}, {{ date }}</td>
            </tr>
            <tr>
              <td>
                <div class="d-flex justify-center">
                  <p class="body-2 mb-0 mr-12">CTT Express</p>
                </div>
                <div class="pl-12">
                  <div class="d-flex justify-center">
                    <img :src="require('@/assets/firma.png')" class="mr-12 director-signature" />
                  </div>

                  <p class="body-1 mb-0 text-left">
                    {{ $t('PAGE2_DIRECTOR_NAME') }}
                  </p>
                  <p class="body-2 mb-12 text-left">
                    {{ $t('PAGE2_DIRECTOR_JOB') }}
                  </p>
                </div>
              </td>
              <td class="pr-12">
                <div class="d-flex justify-center">
                  <p class="body-2 mb-0 mr-12">El cliente</p>
                </div>
                <div class="d-flex align-center pl-12 director-signature">
                  <p class="body-2 mb-0">
                    <span class="white-font">Su-Firma</span>
                  </p>
                </div>

                <p class="body-2 mb-0 text-left">
                  Nombre y Apellidos:
                  <span class="white-font euro-symbol">Nombre-y-Apellidos</span>
                </p>
                <p class="body-2 mb-12 text-left">
                  Cargo de la empresa, NIF:
                  <span class="white-font">Su-DNI-NIF</span>
                </p>
              </td>
            </tr>
          </table>
        </template>
      </div>

      <Footer :page="previousPages + 1 + index" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_OFFER_ITEM } from '@/store/modules/offer/getters'
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2023/Footer'

export default {
  name: 'ServicesAgreement',
  components: { Footer },
  data() {
    return {
      optyServicePoints: [],
      pages: 0,
      pageGroupedServicePoints: [],
      previousPages: 0,
    }
  },
  computed: {
    ...mapGetters('offer', [GET_OFFER_ITEM]),
    clientData() {
      return this[GET_OFFER_ITEM]('client')
    },
    clientSocialReason() {
      return this[GET_OFFER_ITEM]('clientSocialReason')
    },
    selectedPaymentMethod() {
      return this[GET_OFFER_ITEM]('paymentMethods').find(method => method.isSelected)
    },
    bankData() {
      return this[GET_OFFER_ITEM]('bankDetails')
    },
    commitedDeliveries() {
      return this[GET_OFFER_ITEM]('clientCommitedDeliveries')
    },
    paymentDay() {
      return this[GET_OFFER_ITEM]('additionalServices').paymentDay
    },
    location() {
      return (
        `en ${this[GET_OFFER_ITEM]('client').city}` + this[GET_OFFER_ITEM]('clientServicePoint')
      )
    },
    date() {
      let f = new Date()
      return 'a ' + f.getDate() + '/' + (Number(f.getMonth()) + 1) + '/' + f.getFullYear()
    },
  },
  methods: {
    getServicePoints() {
      const unorderedServicePoints = this[GET_OFFER_ITEM]('optyServicePoints')
      const orderedByCompromisedShipmentsServicePoints = unorderedServicePoints.sort((a, b) =>
        a.compromisedShipments < b.compromisedShipments ? 1 : -1,
      )
      return orderedByCompromisedShipmentsServicePoints
    },

    getNumberOfServicePoints() {
      const number = this.optyServicePoints.length
      return number
    },
    getFullServPointsIntermediatePages(numberOfServicePoints) {
      const maxNumberOfServicesPerPage = 14
      const maxNumberOfServicesIn1stPage = 8
      return Math.floor(
        (numberOfServicePoints - maxNumberOfServicesIn1stPage) / maxNumberOfServicesPerPage,
      )
    },
    getServPointsLeft(numberOfServicePoints) {
      const maxNumberOfServicesPerPage = 14
      const maxNumberOfServicesIn1stPage = 8

      return (numberOfServicePoints - maxNumberOfServicesIn1stPage) % maxNumberOfServicesPerPage
    },
    getPages(numberOfServicePoints, fullServPointsIntermediatePages, servPointsLeft) {
      const maxNumberOfServicesIn1stPage = 8
      const maxNumberOfServicesForLastPage = 4
      const maxNumberOfServicesFor2PagesTotal =
        maxNumberOfServicesIn1stPage + maxNumberOfServicesForLastPage

      let pages = 1

      if (numberOfServicePoints > 1 && numberOfServicePoints <= maxNumberOfServicesFor2PagesTotal) {
        pages = 2
      } else {
        pages =
          2 +
          fullServPointsIntermediatePages +
          (servPointsLeft > maxNumberOfServicesForLastPage ? 1 : 0)
      }
      this.$emit('updateTotalPages', { ServicesAgreement: pages })
      return pages
    },
    getPageGroupedServicePoints(
      numberOfServicePoints,
      fullServPointsIntermediatePages,
      servPointsLeft,
    ) {
      const groupedServicePoints = []
      const maxNumberOfServicesIn1stPage = 8
      const maxNumberOfServicesPerPage = 14

      if (numberOfServicePoints <= maxNumberOfServicesIn1stPage) {
        groupedServicePoints.push(this.optyServicePoints.slice(0, numberOfServicePoints))
      } else {
        groupedServicePoints.push(this.optyServicePoints.slice(0, maxNumberOfServicesIn1stPage))
        for (let i = 0; i < fullServPointsIntermediatePages; i++) {
          const initIndex = maxNumberOfServicesIn1stPage + maxNumberOfServicesPerPage * i
          const endIndex = initIndex + maxNumberOfServicesPerPage
          groupedServicePoints.push(this.optyServicePoints.slice(initIndex, endIndex))
        }
        if (servPointsLeft > 0) {
          const lastIndex = maxNumberOfServicesIn1stPage + fullServPointsIntermediatePages * maxNumberOfServicesPerPage;
          groupedServicePoints.push(this.optyServicePoints.slice(lastIndex, lastIndex + servPointsLeft));
        }
      }

      return groupedServicePoints
    },
  },
  created() {
    this.optyServicePoints = this.getServicePoints()
    const numberOfServicePoints = this.getNumberOfServicePoints()
    const fullServPointsIntermediatePages =
      this.getFullServPointsIntermediatePages(numberOfServicePoints)
    const servPointsLeft = this.getServPointsLeft(numberOfServicePoints)
    this.pages = this.getPages(
      numberOfServicePoints,
      fullServPointsIntermediatePages,
      servPointsLeft,
    )
    this.pageGroupedServicePoints = this.getPageGroupedServicePoints(
      numberOfServicePoints,
      fullServPointsIntermediatePages,
      servPointsLeft,
    )
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('ServicesAgreement')
  },
}
</script>
